import { render, staticRenderFns } from "./Treatment.vue?vue&type=template&id=51e00f6a&scoped=true&"
import script from "@/views/Users/Student/Treatment.ts?vue&type=script&lang=ts&"
export * from "@/views/Users/Student/Treatment.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Users/Student/treatment.scss?vue&type=style&index=0&id=51e00f6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e00f6a",
  null
  
)

export default component.exports